//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as InstructionsActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from "lodash";
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------
export const handleListInstructionByUser = (userId) => async (dispatch) => {
    await dispatch(InstructionsActions.listInstructions());
    try {
        const instructions = await apis.get('instructions', `/instructionByUser/${userId}`);
        if (Array.isArray(instructions)) {
            await dispatch(InstructionsActions.listIntstructionsSuccess(instructions));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing instruction by user',
                error,
                module: 'INSTRUCTIONS',
                operation: 'LIST_INSTRUCTION_BOOK_USER'
            });
        }
        await dispatch(InstructionsActions.listInstructionsFail(error));
    }
};

export const handleListInstructionByClass = (classId) => async (dispatch) => {
    await dispatch(InstructionsActions.listInstructions());
    try {
        const instructions = await apis.get('instructions', `/instructionByClass/${classId}`);
        if (Array.isArray(instructions)) {
            await dispatch(InstructionsActions.listIntstructionsSuccess(instructions));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing instruction by class',
                error,
                module: 'INSTRUCTIONS',
                operation: 'LIST_INSTRUCTION_BOOK_CLASS'
            });
        }
        await dispatch(InstructionsActions.listInstructionsFail(error));
    }
};

export const handleCreateInstructions = (data) => async (dispatch) => {
    await dispatch(InstructionsActions.createInstructions());
    try {
        const instructions = await apis.post('instructions', '/instruction', { body: data });
        if (has(instructions, "id") && instructions) {
            await dispatch(InstructionsActions.createIntstructionsuccess(instructions));
        }
        return instructions;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating instructions',
                error,
                module: 'INSTRUCTIONS',
                operation: 'CREATE_INSTRUCTION'
            });
        }
        await dispatch(InstructionsActions.createInstructionsFail(error));
    }
};

export const handleUpdateInstructions = (id,data) => async (dispatch) => {
    await dispatch(InstructionsActions.updateInstructions());
    try {
        const instructions = await apis.put('instructions', `/update/${id}`, { body: data });
        if (has(instructions, "id") && instructions) {
            await dispatch(InstructionsActions.updateIntstructionsSuccess(instructions));
        }
        return instructions;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating instructions',
                error,
                module: 'INSTRUCTIONS',
                operation: 'UPDATE_INSTRUCTION'
            });
        }
        await dispatch(InstructionsActions.updateInstructionsFail(error));
    }
};

export const handleDeleteInstructions = (id) => async (dispatch) => {
    await dispatch(InstructionsActions.deleteInstructions());
    try {
        const instructions = await apis.del('instructions', `/delete/${id}`);
        if (has(instructions, "id") && instructions) {
            await dispatch(InstructionsActions.deleteIntstructionsSuccess(id));
        }
        return instructions;
    } catch (error) {
        if (error && error.message!= "Network Error") {
            logToSentry({
                message: 'deleting instructions',
                error,
                module: 'INSTRUCTIONS',
                operation: 'DELETE_INSTRUCTION'
            });
        }
        await dispatch(InstructionsActions.deleteInstructionsFail(error));
    }
};